var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFetImg10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 88,
    viewBox: "0 0 132 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.910156,
    width: 130.583,
    height: 87.9271,
    rx: 11.5157,
    fill: "#FFEDD1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.5319 19.0024H76.8876C77.173 22.5991 75.8271 25.2865 74.1914 27.2326C72.5865 29.1653 70.3887 31.0397 66.834 30.7553C66.5969 27.2102 67.945 24.7221 69.5785 22.7805C71.0935 20.971 73.8709 19.3608 76.5319 19.0024ZM87.2925 56.4378V56.5386C86.2935 59.6246 84.8686 62.2695 83.1297 64.724C81.5422 66.9523 79.597 69.9509 76.1236 69.9509C73.1222 69.9509 71.1286 67.9824 68.0526 67.9287C64.7987 67.8749 63.0093 69.5747 60.0343 70.0024H59.02C56.8354 69.68 55.0723 67.9152 53.7879 66.3252C50.0005 61.6267 47.0738 55.5577 46.5293 47.7911V45.5091C46.7598 39.9507 49.4077 35.4314 52.9272 33.2411C54.7847 32.0766 57.3381 31.0845 60.1814 31.5279C61.4 31.7205 62.6449 32.146 63.7361 32.5671C64.7702 32.9724 66.0634 33.6913 67.2885 33.6532C68.1185 33.6286 68.944 33.1874 69.7805 32.8761C72.2308 31.9736 74.6328 30.9389 77.7988 31.4249C81.6037 32.0117 84.3043 33.7361 85.9729 36.3966C82.7542 38.486 80.2095 41.6348 80.6443 47.0118C81.0307 51.8961 83.8147 54.7537 87.2925 56.4378Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 51,
    fill: "white",
    transform: "translate(41.9102 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFetImg10);
export default __webpack_public_path__ + "static/media/fet-img (10).852a28e905cad60998a839ea265158f1.svg";
export { ForwardRef as ReactComponent };